

module.service('PlacementService', function(ModelService) {

    function replacePlacementCallback(placement) {
        return function(updated) {
            console.log(updated.education_start);
            angular.copy(updated, placement);
            return placement;
        }
    }

    function updatePlacementAfterwards(placement) {
        return function(result) {
            return ModelService.get('education_placement', placement.id)
                .then(replacePlacementCallback(placement))
                .then(function() { return result; });
        }
    }

    this.createDuration = function(placement, data) {
        data = angular.copy(data);
        data.education_placement_id = placement.id;
        return ModelService.post('education_placement_duration', data)
            .then(updatePlacementAfterwards(placement));
    };

    this.deleteDuration = function(placement, duration) {
        return ModelService.delete('education_placement_duration', duration.id)
            .then(updatePlacementAfterwards(placement));
    };


    this.patchDuration = function(placement, duration, data) {
        return ModelService.patch('education_placement_duration', duration.id, data)
            .then(updatePlacementAfterwards(placement));
    };

    this.patchBrandeis = function(brandeis, data) {
        return ModelService.patch('brandeis_placement', brandeis.id, data)
            .then(function(updated) {
                angular.copy(updated, brandeis);
            });
    };

    this.patchPlacement = function(placement, data) {
        return ModelService.patch('education_placement', placement.id, data)
            .then(replacePlacementCallback(placement));
    };

    this.updatePlacement = function(ModelService, placement) {
        return ModelService.get('education_placement', placement.id)
            .then(replacePlacementCallback(placement));
    };

});
